import React from 'react';
import Navigation from '../components/Navigation';
import HeroSection from '../components/HeroSection';
import TrustStatsSection from '../components/TrustStatsSection';
import ProfessionalOverview from '../components/ProfessionalOverview';
import SpecializationsSection from '../components/SpecializationsSection';
import CareerTimeline from '../components/CareerTimeline';
import EducationSection from '../components/EducationSection';
import ServicesSection from '../components/ServicesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import PublicationsSection from '../components/PublicationsSection';
import AppointmentBooking from '../components/AppointmentBooking';
import LocationsSection from '../components/LocationsSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="homepage">
      <Navigation />
      <HeroSection />
      <TrustStatsSection />
      <ProfessionalOverview />
      <SpecializationsSection />
      <CareerTimeline />
      <EducationSection />
      <ServicesSection />
      <TestimonialsSection />
      <PublicationsSection />
      <AppointmentBooking />
      <LocationsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
